/**
 * @generated SignedSource<<ba74ff3ffa7e2f2f214191399efb91e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SubscriptionList_query$data = {
  readonly subscriptions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly activatedAt: any;
        readonly customerAccount: {
          readonly customerName: string;
          readonly customerNumber: string;
          readonly id: string;
        };
        readonly id: string;
        readonly orderedAt: any;
        readonly state: string;
        readonly subscriptionService: {
          readonly id: string;
          readonly name: string;
        };
        readonly subscriptionServiceReference: string;
        readonly subscriptionServiceReferenceLabel: string | null | undefined;
        readonly subscriptionServiceReferenceUri: string | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"SubscriptionListItem_subscription" | "TerminateSubscriptionDialog_subscription">;
      } | null | undefined;
    }>;
    readonly totalCount: number;
  } | null | undefined;
  readonly " $fragmentType": "SubscriptionList_query";
};
export type SubscriptionList_query$key = {
  readonly " $data"?: SubscriptionList_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"SubscriptionList_query">;
};

import SubscriptionsPaginationQuery_graphql from './SubscriptionsPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "subscriptions"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 100,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "searchTerm"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": SubscriptionsPaginationQuery_graphql
    }
  },
  "name": "SubscriptionList_query",
  "selections": [
    {
      "alias": "subscriptions",
      "args": [
        {
          "kind": "Variable",
          "name": "searchTerm",
          "variableName": "searchTerm"
        },
        {
          "kind": "Literal",
          "name": "sort",
          "value": "ORDERED_AT_DESC"
        }
      ],
      "concreteType": "SubscriptionConnection",
      "kind": "LinkedField",
      "name": "__SubscriptionList_subscriptions_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SubscriptionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Subscription",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "TerminateSubscriptionDialog_subscription"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "SubscriptionListItem_subscription"
                },
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "state",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CustomerAccount",
                  "kind": "LinkedField",
                  "name": "customerAccount",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "customerName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "customerNumber",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SubscriptionService",
                  "kind": "LinkedField",
                  "name": "subscriptionService",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "subscriptionServiceReference",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "subscriptionServiceReferenceLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "subscriptionServiceReferenceUri",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "orderedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "activatedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "299e0a635ae366e6dc9284800d47c07d";

export default node;
